import { ThemeActions } from "../reducers/themeReducer";

export const toggleDrawer = () => (dispatch) =>
  dispatch({ type: ThemeActions.TOGGLE_DRAWER });
export const toggleTheme = (theme) => (dispatch) =>
  dispatch({ type: ThemeActions.TOGGLE_THEME, payload: theme });
